import React, { useEffect, useState } from 'react';
import { Card } from '../components/ui/Card';
import { Table } from '../components/ui/Table';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { mockOrders } from '../utils/mockData';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { X } from 'lucide-react';
export function Orders() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const rangeParam = searchParams.get('range');
  const [searchQuery, setSearchQuery] = useState('');
  // Filter orders by date range
  let filteredOrders = mockOrders;
  if (rangeParam === '30d') {
    const thirtyDaysAgo = Date.now() - 30 * 24 * 60 * 60 * 1000;
    filteredOrders = filteredOrders.filter(order => new Date(order.createdAt).getTime() >= thirtyDaysAgo);
  }
  // Search filter
  if (searchQuery) {
    const query = searchQuery.toLowerCase();
    filteredOrders = filteredOrders.filter(order => order.id.toLowerCase().includes(query) || order.customerName.toLowerCase().includes(query) || order.storeName.toLowerCase().includes(query));
  }
  const handleClearFilters = () => {
    setSearchQuery('');
    setSearchParams({});
  };
  const hasActiveFilters = rangeParam || searchQuery;
  return <div className="space-y-6" data-id="element-815">
      <div className="flex justify-between items-center" data-id="element-816">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-817">Orders</h1>
      </div>

      <Card data-id="element-818">
        <div className="flex gap-4 mb-6" data-id="element-819">
          <div className="flex-1" data-id="element-820">
            <Input placeholder="Search orders by ID, customer, or store..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-821" />
          </div>
          {hasActiveFilters && <Button variant="outline" onClick={handleClearFilters} data-id="element-822">
              <X className="h-4 w-4 mr-2" data-id="element-823" />
              Clear Filters
            </Button>}
        </div>

        {/* Active Filter Badges */}
        {hasActiveFilters && <div className="flex flex-wrap gap-2 mb-4 pb-4 border-b border-gray-200" data-id="element-824">
            {rangeParam === '30d' && <Badge variant="blue" data-id="element-825">Last 30 days</Badge>}
            {searchQuery && <Badge variant="blue" data-id="element-826">Search: "{searchQuery}"</Badge>}
          </div>}

        <Table data={filteredOrders} keyField="id" onRowClick={order => navigate(`/orders/${order.id}`)} columns={[{
        header: 'Order #',
        accessor: o => <span className="font-medium" data-id="element-828">#{o.id.split('_')[1]}</span>
      }, {
        header: 'Store',
        accessor: 'storeName'
      }, {
        header: 'Customer',
        accessor: 'customerName'
      }, {
        header: 'Date',
        accessor: o => new Date(o.createdAt).toLocaleDateString()
      }, {
        header: 'Total',
        accessor: o => `$${o.total.toFixed(2)}`
      }, {
        header: 'Fulfillment',
        accessor: o => o.fulfillmentMethod.replace(/-/g, ' ')
      }, {
        header: 'Status',
        accessor: o => <Badge variant={o.status === 'completed' ? 'green' : 'blue'} data-id="element-829">
                  {o.status.replace('-', ' ')}
                </Badge>
      }]} data-id="element-827" />
      </Card>
    </div>;
}